import "./style.scss";

import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

interface IFailedContent {
    onRedirect: () => void;
}

const FailedContent = ({ onRedirect }: IFailedContent) => {
    const [t] = useTranslation();

    return (
        <div className="failed-content-wrapper">
            <span className="failed-content-sad">{`:( ${t("IntegrationsSettings.Oops")}...`}</span>
            <span>{t("IntegrationsSettings.ErrorOccured")}</span>
            <StyledButton buttonType="primary" onClick={onRedirect} fullWidth>
                {t("IntegrationsSettings.ReturnToCrealo")}
            </StyledButton>
        </div>
    );
};

export default FailedContent;
